import { ITranslateProps, InjectedFormProps } from 'models/common';
import * as React from 'react';
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
const { connect } = require('react-redux');
import * as c from 'models/constants';
import { Link, browserHistory } from 'react-router';
import { deleteSubscriptionPlan, getSubscriptionPlans } from 'redux/modules/subscriptionplans/subscriptionplans';
import { ErrorSummary } from 'components';
import moment = require('moment');
import { ISubscriptionPlan } from 'models/subscriptionplans';
import renderIcon from 'helpers/renderIcon';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
import { getShopCard } from 'redux/modules/shop/shopcard';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { IShopListItem } from 'models/shop/shoplistitem';
import { formatCurrency } from 'helpers/common';
import { getShopsWithActiveSubscriptionPlans, resetData } from 'redux/modules/subscriptionplans/shopsubscriptionplans';
import { InfiniteScrollIntersection } from 'components/Common/InfiniteScrollIntersection';

require('./style.scss');

interface IOwnProps {}

interface IProps
	extends InjectedFormProps,
		IOwnProps,
		ReturnType<typeof stateToProps>,
		ReturnType<typeof dispatchToProps>,
		ITranslateProps {}

type TabName = 'shopplans' | 'allplans';

interface IState {
	selectedTab: TabName;
	imagesDidNotLoad: boolean[];
}

const stateToProps = (state: IStore) => ({
	subscriptionPlansReducer: state.subscriptionPlansReducer,
	shopSubscriptionPlansReducer: state.shopSubscriptionPlansReducer,
});

const dispatchToProps = (dispatch) => ({
	getSubscriptionPlans: () => dispatch(getSubscriptionPlans()),
	deleteSubscriptionPlan: (plan) => dispatch(deleteSubscriptionPlan(plan)),
	getShopsWithActiveSubscriptionPlans: () => dispatch(getShopsWithActiveSubscriptionPlans(undefined, 30)),
	getShopCard: (id: string) => dispatch(getShopCard(id)),
	resetData: () => dispatch(resetData()),
});

const assignArr = (arr, i, value) => {
	arr[i] = value;
	return arr;
};
@connect(stateToProps, dispatchToProps)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminSubscriptionPlans extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			selectedTab: 'shopplans',
			imagesDidNotLoad: [],
		};

		this.onSubscriptionPlanClick = this.onSubscriptionPlanClick.bind(this);
		this.onDeleteSubscriptionPlanClick = this.onDeleteSubscriptionPlanClick.bind(this);
		this.changeTab = this.changeTab.bind(this);
		this.loadMoreShops = this.loadMoreShops.bind(this);
		this.onShopClick = this.onShopClick.bind(this);
	}

	componentDidMount(): void {
		if (this.props.subscriptionPlansReducer?.plans == null) {
			this.props.getSubscriptionPlans();
		}

		this.props.getShopsWithActiveSubscriptionPlans();
	}

	private onSubscriptionPlanClick(plan: ISubscriptionPlan) {
		browserHistory.push(`/admin/subscriptionplans/edit/${plan?.id}`);
	}

	private onDeleteSubscriptionPlanClick(plan: ISubscriptionPlan) {
		this.props.deleteSubscriptionPlan(plan);
	}

	private changeTab(selectedTab: TabName) {
		this.setState({ selectedTab });
	}

	public loadMoreShops() {
		this.props.getShopsWithActiveSubscriptionPlans();
	}

	onShopClick(shop: IShopListItem) {
		browserHistory.push(`/admin/subscriptionplans/shop/${shop.id}`);
	}

	public componentWillUnmount() {
		this.props.resetData();
	}

	public render() {
		const { subscriptionPlansReducer, t } = this.props;
		const items = this.props.shopSubscriptionPlansReducer?.shopsWithActiveSubscriptionPlan?.items;
		const totalItems = this.props.shopSubscriptionPlansReducer?.shopsWithActiveSubscriptionPlan?.totalItems;

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items?.length,
			next: this.loadMoreShops,
			hasMore: totalItems > items?.length,
			loader: <h4>{this.props.t('BSPortal_Common_Loading')} </h4>,
		};

		return (
			<Tabs
				name="boxes"
				selectedTab={this.state.selectedTab}
				handleSelect={this.changeTab}
				tabComponent="div"
				className="adminSubscriptionPlans"
			>
				<div className="tabsHolder">
					<TabLink className="tab" to="shopplans">
						{t('Admin_AdminSubscriptionPlans_Tabs_ShopPlans')}
					</TabLink>
					<TabLink className="tab" to="allplans">
						{t('Admin_AdminSubscriptionPlans_Tabs_AllPlans')}
					</TabLink>
				</div>
				<div className="tabsContent">
					<TabContent for="shopplans">
						<h1>{t('Admin_AdminSubscriptionPlans_Tabs_ShopPlans_Title')}</h1>
						<div className="adminSubscriptionPlans__table-wrapper">
							<InfiniteScrollIntersection {...infiniteScrollProps}>
								<table>
									<thead>
										<tr>
											<td></td>
											<td>{t('Shop_ManageShop_General_Label_ShopName')}</td>
											<td>{t('Admin_ShopSubscriptionPlans_Field_ValidFrom')}</td>
											<td>{t('Admin_ShopSubscriptionPlans_Field_ValidTo')}</td>
											<td>{t('Admin_AdminSubscriptionPlans_Field_SubscriptionPlanName')}</td>
										</tr>
									</thead>
									<tbody>
										{items?.map((shopWithActiveSubscriptionPlan, i) => (
											<tr
												className="adminSubscriptionPlans__clickable-row"
												onClick={() => this.onShopClick(shopWithActiveSubscriptionPlan)}
												key={`AdminSubscriptionPlans_shop_${i}`}
											>
												<td>
													{!shopWithActiveSubscriptionPlan.picture || this.state.imagesDidNotLoad?.[i] ? (
														renderIcon('pfp_salon', 32, 32, 'adminSubscriptionPlans__salonImage--empty')
													) : (
														<img
															className="adminSubscriptionPlans__salonImage"
															src={shopWithActiveSubscriptionPlan.picture}
															alt="shop picture"
															onError={() =>
																this.setState((state) => ({
																	imagesDidNotLoad: assignArr(state.imagesDidNotLoad, i, true),
																}))
															}
														/>
													)}
												</td>
												<td>{shopWithActiveSubscriptionPlan.name}</td>
												<td>
													{shopWithActiveSubscriptionPlan.validFrom &&
														moment(shopWithActiveSubscriptionPlan.validFrom).format('ll')}
												</td>
												<td>
													{shopWithActiveSubscriptionPlan.validTo &&
														moment(shopWithActiveSubscriptionPlan.validTo).format('ll')}
												</td>
												<td>{shopWithActiveSubscriptionPlan.subscriptionPlanName}</td>
											</tr>
										))}
									</tbody>
								</table>
							</InfiniteScrollIntersection>
						</div>
					</TabContent>
					<TabContent for="allplans">
						<h1>{t('Admin_AdminSubscriptionPlans_Tabs_AllPlans')}</h1>

						<ErrorSummary message={subscriptionPlansReducer.message} error={subscriptionPlansReducer.error} />

						<div className="adminSubscriptionPlans__table-wrapper">
							<table>
								<thead>
									<tr>
										<td>{t('Admin_AdminSubscriptionPlans_Field_Name')}</td>
										<td>{t('Admin_AdminSubscriptionPlans_Field_Country')}</td>
										<td>{t('Admin_AdminSubscriptionPlans_Field_SMSPrice')}</td>
										<td>{t('Admin_AdminSubscriptionPlans_Field_FreeEmails')}</td>
										<td>{t('Admin_AdminSubscriptionPlans_Field_FreeSmss')}</td>
										<td>{t('Admin_AdminSubscriptionPlans_Field_IsBundlesEnabled')}</td>
										<td>{t('Admin_AdminSubscriptionPlans_Field_AddedBy')}</td>
										<td>{t('Admin_AdminSubscriptionPlans_Field_AddedDate')}</td>
										<td></td>
									</tr>
								</thead>
								<tbody>
									{subscriptionPlansReducer?.plans?.map((plan, i) => (
										<tr key={`AdminSubscriptionPlans_plan_${i}`} className={i % 2 == 0 ? '--even' : ''}>
											<td
												onClick={() => {
													this.onSubscriptionPlanClick(plan);
												}}
												className={`adminSubscriptionPlans__clickable-coulmn`}
											>
												{plan.name}
											</td>
											<td>{t(`DV_Countries_${plan.countryKey}`)}</td>
											<td>{plan.smsPrice && plan.currencyKey && formatCurrency(plan.currencyKey, plan.smsPrice)}</td>
											<td>{plan.freeEmails}</td>
											<td>{plan.freeSmss}</td>
											<td
												className={`adminSubscriptionPlans__checkbox-coulmn ${
													plan.isBundlesEnabled ? 'adminSubscriptionPlans__checkbox-coulmn--checked' : ''
												}`}
											>
												{plan.isBundlesEnabled ? renderIcon('check') : renderIcon('cancel')}
											</td>
											<td>{plan.addedBy}</td>
											<td>{moment(plan.addedDate).format('L')}</td>
											<td className={`adminSubscriptionPlans__clickable-coulmn--red`}>
												{renderIcon('cancel', undefined, undefined, undefined, () =>
													this.onDeleteSubscriptionPlanClick(plan),
												)}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
						<div className="adminSubscriptionPlans__add-plan">
							<Link to={`/admin/subscriptionplans/edit`}>
								{renderIcon('nikaPlus')} {t('Admin_AdminSubscriptionPlans_NewPlan')}
							</Link>
						</div>
					</TabContent>
				</div>
			</Tabs>
		);
	}
}

export { AdminSubscriptionPlans };
